import React from "react"
import { concatStrings, categoryIconMapping } from "../utilities"

const DfbSymbol = props => {
  var svgClass = ""
  var useHash = ""

  var categoryIconData = categoryIconMapping(props.icon_type)

  if (categoryIconData) {
    svgClass = categoryIconData.svgClass
    useHash = categoryIconData.useHash
  } else {
    svgClass = props.icon_type
      .replace(/ & /g, "-")
      .replace(/ /g, "-")
      .replace(/ö/g, "oe")
      .replace(/o\u0308/g, "oe")
      .replace(/ä/g, "ae")
      .replace(/a\u0308/g, "ae")
      .replace(/ü/g, "ue")
      .replace(/u\u0308/g, "ue")
    useHash = svgClass.toLowerCase()
  }

  if (props.icon_type === "PlayCircle") {
    svgClass = "PlayCircle"
    useHash = "play-circle"
  }

  if (
    props.icon_type.includes("Sponsoring") ||
    props.icon_type.includes("sponsoring")
  ) {
    return (
      // Spezialfall bei den Sponsoren Logos
      <svg
        className={concatStrings(
          "dfb-Symbol dfb-Symbol--dfb" + svgClass,
          props.add_class
        )}
        aria-hidden="true"
      >
        <use xlinkHref={"#dfb-" + useHash} href={"#dfb-" + useHash} />
      </svg>
    )
  } else {
    return (
      <svg
        className={concatStrings(
          "dfb-Symbol dfb-Symbol--dfbIcon" + svgClass,
          props.add_class
        )}
        aria-hidden="true"
      >
        <use xlinkHref={"#dfb-icon-" + useHash} href={"#dfb-icon-" + useHash} />
      </svg>
    )
  }
}

export default DfbSymbol
